module.exports = __webpack_public_path__ + "img/x6.1f608a28.png";